/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanState {
    READY = 'ready',
    CREATING = 'creating',
    UPDATING = 'updating',
    FAILED_TO_CREATE = 'failedToCreate',
    FAILED_TO_UPDATE = 'failedToUpdate',
}
